// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ProfileSettingsModule__avatar__mSLeO","avatarTitle":"ProfileSettingsModule__avatarTitle__wfKBR","avatarField":"ProfileSettingsModule__avatarField__8OjvI"};